import { Map } from 'immutable';

import { shapePersonalizationQuestionsForAPI } from '@/utils/product/shapeAttributes';
import { getSize } from '@/utils/iterable/getSize';

import { ENABLED, ERROR, REQUIRED, VALUE } from '@/constants/product';
import { FIND, OPERATIONS, REPLACE } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';
import { FEATURE } from '@/constants/features';
import { ETSY } from '@/constants/channels';

export function personalization({ channel, operation, preview, userFeatures }) {
  const payload = [];

  if (!userFeatures.get(FEATURE.ETSY_PERSONALIZATION_QUESTIONS)) {
    if (preview.hasIn([ATTRIBUTE.PERSONALIZATION, ENABLED])) {
      payload.push(
        Map({
          type: OPERATIONS[channel].PERSONALIZATION.IS_PERSONALIZABLE_SET,
          value: preview.getIn([ATTRIBUTE.PERSONALIZATION, ENABLED]),
        })
      );

      if (!preview.getIn([ATTRIBUTE.PERSONALIZATION, ENABLED])) return { payload };
    }

    if (preview.hasIn([ATTRIBUTE.PERSONALIZATION, REQUIRED])) {
      payload.push(
        Map({
          type: OPERATIONS[channel].PERSONALIZATION.IS_REQUIRED_SET,
          value: preview.getIn([ATTRIBUTE.PERSONALIZATION, REQUIRED]),
        })
      );
    }

    if (
      preview.hasIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS]) &&
      !preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, ERROR])
    ) {
      let value;

      switch (operation) {
        case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE: {
          value = Map({
            find: preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, FIND]),
            replace: preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, REPLACE]),
          });

          break;
        }

        default: {
          value = preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE]);
          break;
        }
      }

      payload.push(Map({ type: operation, value }));
    }

    if (
      preview.hasIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.CHAR_COUNT_MAX]) &&
      !preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.CHAR_COUNT_MAX, ERROR])
    ) {
      payload.push(
        Map({
          type: OPERATIONS[channel].PERSONALIZATION.CHAR_COUNT_MAX_SET,
          value: preview.getIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.CHAR_COUNT_MAX, VALUE]),
        })
      );
    }
  } else if (
    !preview.getIn([ATTRIBUTE.PERSONALIZATION, ERROR]) ||
    getSize(preview.getIn([ATTRIBUTE.PERSONALIZATION, VALUE])) > 0
  ) {
    payload.push(
      Map({
        type: OPERATIONS[ETSY].PERSONALIZATION_QUESTIONS,
        value: shapePersonalizationQuestionsForAPI({ questions: preview.getIn([ATTRIBUTE.PERSONALIZATION, VALUE]) }),
      })
    );
  }

  return { payload };
}
